import React from 'react';
import { FadeIn } from './FadeIn';
export function AboutBrand() {
  return <section id="nosotros" className="py-24 md:py-32 bg-beige relative overflow-hidden" data-id="element-13">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10" data-id="element-14">
        <FadeIn data-id="element-15">
          <span className="font-sans text-sm font-bold tracking-widest text-textoSuave uppercase mb-4 block" data-id="element-16">
            Nuestra Misión
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-texto mb-8" data-id="element-17">
            Un espacio para entenderte mejor
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-18">
          <p className="font-sans text-lg md:text-2xl text-textoSuave leading-relaxed mb-12" data-id="element-19">
            Habitando mi cuerpo nace para acompañar a mujeres que desean
            conocerse desde un lugar más real, más amoroso y más consciente. A
            través de ebooks digitales, buscamos acercar información, reflexión
            y contención sobre procesos físicos, emocionales y hormonales que
            forman parte de la experiencia femenina.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-20">
          <a href="#ebooks" className="inline-flex items-center justify-center px-8 py-3.5 rounded-full bg-blanco text-texto font-medium hover:bg-crema shadow-sm transition-all duration-300" data-id="element-21">
            Saber más
          </a>
        </FadeIn>
      </div>

      {/* Decorative botanical/abstract element */}
      <div className="absolute bottom-0 right-0 opacity-10 pointer-events-none transform translate-x-1/4 translate-y-1/4" data-id="element-22">
        <svg width="400" height="400" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-23">
          <path d="M100 200C100 200 100 100 200 100C200 100 100 100 100 0C100 0 100 100 0 100C0 100 100 100 100 200Z" fill="#4A3B3B" data-id="element-24" />
        </svg>
      </div>
    </section>;
}